import request from '@/utils/request'


// 查询发现板块-用户搜索列表
export function listDiscoverUserSearch(query) {
  return request({
    url: '/discovery/discover/user/search/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-用户搜索分页
export function pageDiscoverUserSearch(query) {
  return request({
    url: '/discovery/discover/user/search/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-用户搜索详细
export function getDiscoverUserSearch(data) {
  return request({
    url: '/discovery/discover/user/search/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-用户搜索
export function addDiscoverUserSearch(data) {
  return request({
    url: '/discovery/discover/user/search/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-用户搜索
export function updateDiscoverUserSearch(data) {
  return request({
    url: '/discovery/discover/user/search/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-用户搜索
export function delDiscoverUserSearch(data) {
  return request({
    url: '/discovery/discover/user/search/delete',
    method: 'post',
    data: data
  })
}
